import { TAB_TITLE } from 'constants/dealDriver';

export const DISCOUNT_MODAL_TABS = [
	{ title: TAB_TITLE.SELLER, requestType: 'absolute_sale_guarantee_request' },
	{ title: TAB_TITLE.BUYER, requestType: 'buy_fee_discount_request' },
];

export const REASON_CODES = {
	new_buyer: 'new_buyer',
	new_seller: 'new_seller',
	winback: 'winback',
	final_gap_resolution: 'final_gap_resolution',
	short_sold: 'short_sold',
	promotion: 'promotion',
	other: 'other',
};

export const REQUEST_TYPES = {
	buy_fee_discount: 'buy_fee_discount',
	absolute_sale_guarantee: 'absolute_sale_guarantee',
};

// Temporary local defaults for the UI-only modal. Replace with wired values once discounts submit/state is integrated.
export const DISCOUNT_MODAL_FIELDS = {
	DIRECTOR: 'director_id',
	SELLER_REASON: 'seller_reason',
	SELLER_VALUE: 'seller_value',
	SELLER_OTHER_REASON: 'seller_other_reason',
	BUYER_DEALERSHIP: 'buyer_dealership',
	BUYER_USER: 'buyer_user',
	BUYER_REASON: 'buyer_reason',
	BUYER_VALUE: 'buyer_value',
	BUYER_OTHER_REASON: 'buyer_other_reason',
};

// UI-only metadata used by local validation flow. This should move to persisted modal state once wired.
export const DISCOUNT_MODAL_META_FIELDS = {
	ACTIVE_TAB: 'active_tab',
	CURRENT_BUY_FEE: 'current_buy_fee',
};

// Temporary local defaults for the UI-only modal. Replace with wired values once discounts submit/state is integrated.
export const DISCOUNT_MODAL_FORM_DEFAULT_VALUES = {
	[DISCOUNT_MODAL_META_FIELDS.ACTIVE_TAB]: TAB_TITLE.SELLER,
	[DISCOUNT_MODAL_META_FIELDS.CURRENT_BUY_FEE]: '',
	[DISCOUNT_MODAL_FIELDS.DIRECTOR]: '',
	[DISCOUNT_MODAL_FIELDS.SELLER_REASON]: '',
	[DISCOUNT_MODAL_FIELDS.SELLER_VALUE]: '',
	[DISCOUNT_MODAL_FIELDS.SELLER_OTHER_REASON]: '',
	[DISCOUNT_MODAL_FIELDS.BUYER_DEALERSHIP]: '',
	[DISCOUNT_MODAL_FIELDS.BUYER_USER]: '',
	[DISCOUNT_MODAL_FIELDS.BUYER_REASON]: '',
	[DISCOUNT_MODAL_FIELDS.BUYER_VALUE]: '',
	[DISCOUNT_MODAL_FIELDS.BUYER_OTHER_REASON]: '',
};

export const DISCOUNT_OTHER_REASON_VALUE = REASON_CODES.other;

export const DISCOUNT_BUYER_USERS_PER_PAGE = 100;
export const DISCOUNT_DIRECTORS_PER_PAGE = 10;
export const DISCOUNT_DIRECTOR_SEARCH_DEBOUNCE_MS = 1000;

// Temporary compatibility list for legal user hints from users endpoint payloads.
// Keep until backend contracts are finalized for discounts buyer-user defaults.
export const LEGAL_USER_FLAG_KEYS = ['is_legal_user', 'legal_user', 'is_legal', 'legal', 'isLegalUser'];

export const DISCOUNT_REASON_OPTIONS = [
	{ value: REASON_CODES.new_buyer, text: 'New buyer' },
	{ value: REASON_CODES.new_seller, text: 'New seller' },
	{ value: REASON_CODES.winback, text: 'Win back' },
	{ value: REASON_CODES.final_gap_resolution, text: 'Final gap resolution' },
	{ value: REASON_CODES.short_sold, text: 'Short sold' },
	{ value: REASON_CODES.promotion, text: 'Promotion' },
	{ value: REASON_CODES.other, text: 'Other' },
];
